<div
  [class]="getClassName()"
  appElevation
  [elevation]="elevation()"
  [clickable]="clickable()"
  [imTooltip]="tooltipText()"
  [openDelay]="300"
  (click)="badgeClick($event)"
>
  @if (icon()) {
    <span
      [class]="'me-1 icon icon--' + icon()"
      [class.semibold]="fontBold()"
    ></span>
  }
  <span
    [class]="baseClass + '__inner'"
    [class.uppercase]="uppercase()"
    [class.semibold]="fontBold()"
    [style.overflow]="allowOverflow() ? 'visible' : null"
  >
    <ng-content></ng-content>
  </span>
  @if (withCloseButton()) {
    <button
      [class]="[baseClass + '__button', 'p-0 ps-1']"
      (click)="closeButtonClick($event)"
    >
      ✕
    </button>
  }
</div>
